module.exports = __webpack_public_path__ + "static/media/golf-ball.6d2d8852.svg";